<template>
  <div class="container">
    <header>
      <h1 v-if="!isHomePage">Aertix</h1>
      <nav>
        <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle menu">
          <span></span>
          <span></span>
        </button>
        <ul :class="{ show: menuOpen }">
          <li><router-link to="/about">About</router-link></li>
          <li><router-link to="/projects">Projects</router-link></li>
          <li><router-link to="/contact">Contact</router-link></li>
        </ul>
      </nav>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer>
      <p>&copy; {{ currentYear }} Aertix. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    isHomePage() {
      return this.$route.path === '/'
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: Arial, sans-serif;
  color: #333;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 4rem;
  background: rgba(255, 255, 255, 0.98);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

h1 {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.75rem;
  font-weight: 300;
  letter-spacing: -0.5px;
  margin: 0;
  color: #1a1a1a;
  opacity: 0.7;
}

nav {
  position: relative;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
}

.menu-toggle span {
  width: 2rem;
  height: 1px;
  background: #1a1a1a;
  opacity: 0.7;
  transition: all 0.3s ease;
}

nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2.5rem;
}

@media (max-width: 768px) {
  nav ul {
    position: fixed;
    right: 1.5rem;
    top: 5rem;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 1rem;
    display: none;
    min-width: 150px;
    z-index: 1001;
  }

  header {
    padding: 1rem 1.5rem;
  }
}

nav ul li {
  margin-left: 1rem;
}

nav ul li a {
  color: #1a1a1a;
  opacity: 0.7;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.01em;
  transition: all 0.3s ease;
}

nav ul li a:hover,
nav ul li a.router-link-active {
  opacity: 1;
  transform: translateY(-2px);
}

main {
  flex: 1;
}

footer {
  padding: 1rem;
  text-align: center;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .menu-toggle {
    display: flex;
  }

  nav ul {
    flex-direction: column;
    position: absolute;
    right: 0;
    top: 100%;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 1rem;
    display: none;
  }

  nav ul.show {
    display: flex;
  }

  nav ul li {
    margin: 0.5rem 0;
  }

  header {
    padding: 1.5rem;
  }

  nav ul {
    background: rgba(255, 255, 255, 0.98);
  }
}
</style>
